/**
 * Primitives de formulaire — pensées pour la saisie debout, à une main.
 * Chaque contrôle atteint la cible tactile minimale via les classes de base.css.
 */
import { useId, type ReactNode } from 'react';

export function Champ({
  label,
  aide,
  ...props
}: { label: string; aide?: string } & React.InputHTMLAttributes<HTMLInputElement>) {
  const id = useId();
  return (
    <div className="champ">
      <label htmlFor={id} className="champ__label">
        {label}
      </label>
      <input id={id} className="champ__saisie" {...props} />
      {aide && <p className="champ__aide">{aide}</p>}
    </div>
  );
}

export function Zone({
  label,
  aide,
  ...props
}: { label: string; aide?: string } & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const id = useId();
  return (
    <div className="champ">
      <label htmlFor={id} className="champ__label">
        {label}
      </label>
      <textarea id={id} className="champ__saisie champ__saisie--zone" rows={3} {...props} />
      {aide && <p className="champ__aide">{aide}</p>}
    </div>
  );
}

export function Selection({
  label,
  options,
  ...props
}: {
  label: string;
  options: { valeur: string; texte: string }[];
} & React.SelectHTMLAttributes<HTMLSelectElement>) {
  const id = useId();
  return (
    <div className="champ">
      <label htmlFor={id} className="champ__label">
        {label}
      </label>
      <select id={id} className="champ__saisie" {...props}>
        <option value="">—</option>
        {options.map((o) => (
          <option key={o.valeur} value={o.valeur}>
            {o.texte}
          </option>
        ))}
      </select>
    </div>
  );
}

/**
 * Case de consentement : la case est volumineuse, le texte est cliquable en
 * entier, et rien n'est jamais pré-coché — le composant n'accepte même pas de
 * `defaultChecked`.
 */
export function CaseConsentement({
  texte,
  coche,
  onChange,
  enfants,
}: {
  texte: string;
  coche: boolean;
  onChange: (valeur: boolean) => void;
  enfants?: ReactNode;
}) {
  const id = useId();
  return (
    <div className={`case-consentement${coche ? ' case-consentement--cochee' : ''}`}>
      <input
        type="checkbox"
        id={id}
        checked={coche}
        onChange={(e) => onChange(e.target.checked)}
        className="case-consentement__case"
      />
      <label htmlFor={id} className="case-consentement__texte">
        {texte}
        {enfants}
      </label>
    </div>
  );
}
